import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconKeyboard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.2 12.6667C2.87 12.6667 2.5875 12.5454 2.3525 12.303C2.1175 12.0605 2 11.769 2 11.4286V5.2381C2 4.89762 2.1175 4.60615 2.3525 4.36369C2.5875 4.12123 2.87 4 3.2 4H12.8C13.13 4 13.4125 4.12123 13.6475 4.36369C13.8825 4.60615 14 4.89762 14 5.2381V11.4286C14 11.769 13.8825 12.0605 13.6475 12.303C13.4125 12.5454 13.13 12.6667 12.8 12.6667H3.2ZM3.2 11.4286H12.8V5.2381H3.2V11.4286ZM5.6 10.8095H10.4V9.57143H5.6V10.8095ZM3.8 8.95238H5V7.71429H3.8V8.95238ZM5.6 8.95238H6.8V7.71429H5.6V8.95238ZM7.4 8.95238H8.6V7.71429H7.4V8.95238ZM9.2 8.95238H10.4V7.71429H9.2V8.95238ZM11 8.95238H12.2V7.71429H11V8.95238ZM3.8 7.09524H5V5.85714H3.8V7.09524ZM5.6 7.09524H6.8V5.85714H5.6V7.09524ZM7.4 7.09524H8.6V5.85714H7.4V7.09524ZM9.2 7.09524H10.4V5.85714H9.2V7.09524ZM11 7.09524H12.2V5.85714H11V7.09524Z",
		fill: "#5C5C5C"
	})
});
export default SvgIconKeyboard;
